import 'password-strength-meter';
import jQuery from 'jquery';

jQuery(($) => {
  let newPasswordInputEl = $('#new_password');

  if (newPasswordInputEl.length > 0) {
    newPasswordInputEl.password({
      minimumLength: 7
    });
  }
});